/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://mdh81vphg7.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "commandApi",
            "endpoint": "https://n89y5u6nti.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "sdautoApi",
            "endpoint": "https://two6oxpojg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "stripeWebhook",
            "endpoint": "https://a1z4kgj6u5.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gjccamv6szcldhda7iojksikb4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3fckxp5icjdxtml2uby6ids6qm",
    "aws_cognito_identity_pool_id": "us-east-1:9cb6ec32-f841-409a-83db-f1ef89d6d9aa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_fBevD3wp1",
    "aws_user_pools_web_client_id": "63j2p33nnkaksei5vhqof2vpme",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "badesk-storagedemo-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
